let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "299",
        trackFullPrice: '500',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1676472108782x732427574395273200',
        // earlyBird: true,
    },
    {
        trackTitle: `API Forum 2023
+`,
        secondEvent: "Software Architecture Summit'24",
        secondEventLink: "https://events.geekle.us/wsas/",
        trackPrice: "399",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Two Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1684482176390x530452557012402200',
    },
    {
        trackTitle: "ChatGPT best practices Package",
        event1: "API Forum 2023",
        event2: "GPTcoding for Frontend Developers Conference'23",
        event2Link: "https://events.geekle.us/gpt/",
        event3: "GPTcoding for Backend Developers Summit’23",
        event3Link: "https://events.geekle.us/gpt-backend/",
        trackPrice: "449",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1685964033508x445180673437728800',
        validDate: '9.06',
        inverseColors: true,
    },
    // {
    //     trackTitle: "Year of API Events",
    //     year: "Full Access to the live stream and recordings for 4 events in the API domain",
    //     trackPrice: "549",
    //     trackFullPrice: '1200',
    //     trackDesc: "1",
    //     trackButton: "Register",
    //     trackList1: 'Live event + Recordings',
    //     trackLink: 'https://geekle.us/ticket/1683108085014x173278013685235700',
    // },
    // {
    //     id: 2,
    //     trackTitle: "Junior Track",
    //     trackJunior: true,
    //     trackSubtitle: "For Junior specialists",
    //     trackPrice: "0",
    //     trackButton: "Register",
    //     trackLink: 'https://geekle.us/ticketfree/1673604825930x165995226557054980',
    // },
];

export default PackagesItem;
